import { frontendURL } from '../../../helper/URLHelper';
const VentasView = () => import('./VentasProductionView.vue');

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/ventas'),
      name: 'ventas_view',
      component: VentasView,
      meta: { permissions: ['administrator', 'agent'] },
    },
    {
      path: frontendURL('accounts/:accountId/metricas'),
      name: 'metricas_view',
      redirect: to => ({ name: 'ventas_view', params: to.params }),
      meta: { permissions: ['administrator', 'agent'] },
    },
  ],
};
